import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import { Steps } from 'antd';
import { useTranslation } from 'react-i18next';

const { Step } = Steps;

const Historic = ({ data }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Steps orientation="vertical" current={data.length + 1}>
        {(data || [])
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .map((item) => (
            <Step
              key={item.type}
              title={t(`historic.${item.type}`)}
              description={
                <>
                  {item.value ? <span>{t(`historic.${item.value}`)}</span> : ''}
                  {item.effective_date && (
                    <span>
                      {` effectif le ${format(
                        new Date(item.date),
                        'dd/MM/yyyy'
                      )} `}
                    </span>
                  )}
                  {item.remuneration && (
                    <div>{`Votre rémunération: ${item.remuneration}€/mois`}</div>
                  )}
                  {item.amount && item.fees && (
                    <div>
                      {`Montant de la facture: ${item.amount}€ + ${item.fees}€ de frais`}
                    </div>
                  )}
                  <div>
                    {`Fait le ${format(
                      new Date(item.date),
                      'dd/MM/yyyy HH:mm'
                    )}`}
                  </div>
                </>
              }
            />
          ))}
      </Steps>
    </div>
  );
};

Historic.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({}))
};

Historic.defaultProps = {
  data: []
};

export default Historic;
